export const UPDATE_EVENT_OPENINGS_SHARED_FILTERS =
  'UPDATE_EVENT_OPENINGS_SHARED_FILTERS';

export const UPDATE_ALL_DISTRICTS_EVENTS_FILTERS =
  'UPDATE_ALL_DISTRICTS_EVENTS_FILTERS';

export const SET_SHOW_DISTRICTS_WITHOUT_EVENTS =
  'SET_SHOW_DISTRICTS_WITHOUT_EVENTS';

export const UPDATE_HOST_EVENTS_FILTERS = 'UPDATE_HOST_EVENTS_FILTERS';

export const UPDATE_K12_ADMIN_EVENTS_FILTERS =
  'UPDATE_K12_ADMIN_EVENTS_FILTERS';
